import { IconQuestionMarkOutline } from '@iwoca/icons';
import { Accordion } from '@iwoca/orion';

export const RBLFAQs = ({
    trackFaqClicked
}: {
    trackFaqClicked: (faqTitle: string) => void;
}) => {
    return (
        <div className="col-span-1 grid gap-s">
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title="Über Mindestrückzahlungen"
                small
                data-testid="about-minimum-repayments"
                onClick={() => trackFaqClicked('Über Mindestrückzahlungen')}
            >
                <p>
                    eBay leitet den von Ihnen{' '}
                    <strong>
                        festgelegten Teil Ihrer Umsätze automatisch als
                        Rückzahlung an iwoca weiter.
                    </strong>{' '}
                    Alle 60 Tage muss die Summe dieser Rückzahlungen mindestens
                    die Hälfte Ihrer bis dahin erwarteten Rückzahlungen
                    entsprechen. Sollten sinkende Umsätze dazu führen, dass
                    diese Mindestrückzahlung nicht erreicht wird, ziehen wir den
                    Differenzbetrag per Lastschrift von Ihrem Geschäftskonto
                    ein.
                </p>
            </Accordion>
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title="Kann ich eine Kreditaufstockung beantragen?"
                small
                data-testid="can-i-request-an-increase"
                onClick={() =>
                    trackFaqClicked(
                        'Kann ich eine Kreditaufstockung beantragen?'
                    )
                }
            >
                <>
                    Sie können eine Kreditaufstockung anfragen,{' '}
                    <strong>
                        wenn Sie weniger als 70% Ihres Kreditsrahmens in
                        Anspruch nehmen.
                    </strong>{' '}
                    In Ihrem Kundenprofil sehen Sie, ob eine Aufstockung möglich
                    ist. Ist Ihre Anfrage erfolgreich, beginnt wieder eine neue
                    Laufzeit für die gesamte Kredithöhe.
                    <br /> <br />
                    Die Anfrage sowie die Bearbeitung sind für Sie{' '}
                    <strong>kostenlos und unverbindlich.</strong> Wenn wir Ihnen
                    einen Kredit anbieten, haben Sie einige Tage Zeit zu
                    entscheiden, ob Sie den Kredit ganz oder auch nur teilweise
                    aufnehmen. <br />
                    <br />
                    Wir vergeben Kredite von 1.000 € bis 500.000 €.
                </>
            </Accordion>
        </div>
    );
};
